var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 305,
    viewBox: "0 0 260 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255_89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.993 96.2441L137.236 89.0029L162.459 114.215L155.215 121.456L129.993 96.2441ZM45.2911 141.388C34.2854 130.386 34.2856 112.527 45.2911 101.525C56.2034 90.6173 73.9176 90.6165 84.8301 101.524L97.5264 114.216L90.2832 121.456L77.587 108.765C70.6748 101.856 59.4462 101.856 52.5342 108.766C45.5291 115.768 45.5299 127.144 52.5352 134.146L65.0606 146.668L57.8174 153.908L45.2911 141.388ZM187.68 153.908L162.457 128.695L169.701 121.455L194.923 146.668L187.68 153.908ZM97.5274 128.696L104.771 121.456L129.993 146.668L122.749 153.908L97.5274 128.696ZM214.72 206.267C203.793 217.189 186.054 217.19 175.127 206.267L171.506 202.646L162.458 193.602L169.701 186.36L182.403 199.058C189.333 205.95 200.561 205.939 207.477 199.026C214.468 192.038 214.467 180.686 207.477 173.697L194.924 161.148L202.167 153.908L214.72 166.456C225.711 177.443 225.712 195.279 214.72 206.267ZM129.992 161.148L137.235 153.908L162.457 179.12L155.214 186.36L129.992 161.148ZM65.0616 161.148L72.3047 153.908L97.5264 179.121L90.2832 186.361L65.0616 161.148ZM97.5264 193.602L104.77 186.36L129.992 211.572L122.749 218.814L97.5264 193.602Z",
    fill: "url(#paint0_linear_255_89)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_255_89)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.992 211.572L122.749 218.813L110.258 231.299C99.2327 242.32 99.2321 260.211 110.258 271.232C121.151 282.121 138.834 282.121 149.727 271.232C160.752 260.211 160.752 242.321 149.727 231.299L137.236 218.813L162.457 193.601L169.701 186.36L191.953 164.117L194.923 161.148L202.167 153.907L214.436 141.643C225.583 130.5 225.584 112.41 214.436 101.267C203.665 90.5004 186.181 90.5004 175.411 101.267L162.458 114.214L155.214 121.455L129.992 146.667L122.749 153.907L105.736 170.913L97.5266 179.119L90.2832 186.36L77.5102 199.128C70.6409 205.994 59.4818 205.994 52.6124 199.128C45.5642 192.083 45.5639 180.637 52.6124 173.591L65.0615 161.147L72.3046 153.907L97.5266 128.695L104.77 121.455L129.992 96.2427L137.235 89.002L149.992 76.2496C160.871 65.3747 160.871 47.7219 149.992 36.8471C138.953 25.8119 121.032 25.8119 109.992 36.8471C99.113 47.722 99.113 65.3747 109.992 76.2496L122.749 89.002L97.5265 114.214L90.2831 121.455L65.0611 146.667L57.818 153.907L45.3691 166.351C34.3202 177.396 34.3214 195.324 45.3695 206.368C56.2393 217.233 73.8839 217.233 84.7535 206.368L97.5267 193.6L104.77 186.359L120.247 170.889L129.992 161.148L137.235 153.907L157.771 133.38L162.458 128.695L169.701 121.455L182.654 108.507C189.424 101.74 200.422 101.74 207.193 108.507C214.34 115.652 214.34 127.258 207.193 134.402L194.923 146.667L187.68 153.907L162.458 179.119L155.214 186.36L129.992 211.572ZM117.501 238.54L129.992 226.054L142.483 238.54C149.509 245.562 149.508 256.97 142.483 263.992C135.591 270.882 124.394 270.882 117.501 263.992C110.476 256.969 110.476 245.562 117.501 238.54ZM117.235 69.0091L129.992 81.7617L142.749 69.0091C149.628 62.133 149.628 50.9636 142.749 44.0876C135.71 37.0512 124.275 37.0512 117.235 44.0876C110.357 50.9636 110.357 62.133 117.235 69.0091Z",
    fill: "url(#paint1_linear_255_89)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.001,
    cy: 250.903,
    rx: 8.19278,
    ry: 8.19425,
    transform: "rotate(-180 130.001 250.903)",
    fill: "#FFC84C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 130.001,
    cy: 55.5968,
    rx: 8.19278,
    ry: 8.19425,
    transform: "rotate(-180 130.001 55.5968)",
    fill: "#E03321"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_255_89",
    x: 31.3821,
    y: 22.8703,
    width: 197.115,
    height: 262.228,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_255_89"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_255_89",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_89",
    x1: 124.479,
    y1: 54.4499,
    x2: 72.3074,
    y2: 196.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC84C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_89",
    x1: 129.992,
    y1: 250.852,
    x2: 129.88,
    y2: 54.6147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E13321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC84C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 305,
    fill: "white",
    transform: "translate(260 305) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradient);
export default __webpack_public_path__ + "static/media/Gradient.f5c2ead10cfc24742ff6e4168c68813c.svg";
export { ForwardRef as ReactComponent };